<template>
    <div class="stripe-field-wrapper">
        <div class="stripe-field-container" v-bind:class="fieldClass">
            <label>{{ label }}</label>
            <input :name="name"
                class="stripe-field"
                :type="type"
                :required="required"
                :value="value"
                ref="input"
                @input="handleInput"
                @focus="focus = true"
                @blur="validate(); focus = false" />
        </div>
        <div class="error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: 'checkout-field',
    props: {
        'name': {
            type: String
        },
        'value': {
            type: String
        },
        'label': {
            type: String,
            default: ''
        },
        'type': {
            type: String,
            default: 'text'
        },
        'required': {
            type: Boolean,
            default: true
        },
        'validation': {
            type: String,
            default: ''
        },
        'validator': {
            type: Function,
        }
    },
    data() {
        return {
            focus: false,
            error: ''
        }
    },
    methods: {
        validate () {
            this.error = "";
            var value = this.$refs.input.value;
            if(!value && this.required) {
                this.error = "This is a required field";
                return;
            }
            if (this.type == 'email' && !this.validEmail(value)) {
                this.error = "Invalid email address";
                return;
            }
            if(typeof this.validator === 'function') {
                this.error = this.validator(value);
                return;
            }
        },
        handleInput () {
            var value = this.$refs.input.value;
            this.$emit('input', value);
        },
        validEmail: function (value) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(value);
        },
    },
    computed: {
        fieldClass: function(component) {
            return {
                placeholder: !this.value && !this.focus,
                'validation-failed': this.error != ''
            }
        }
    }
};
</script>